<template>
    <v-dialog v-model="show" persistent width="744">
        <v-card>
            <v-card-title class="headline grey lighten-2 py-2" primary-title>
                <v-layout justify-space-between align-center>
                    <div>
                        {{$t('selectACampaign') | capitalize}}
                    </div>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-layout justify-space-between>
                    <v-flex xs6>
                        <v-text-field
                            v-model="search"
                            :placeholder="$t('searchACampaign') | capitalize"
                            append-icon="mdi-magnify"
                        ></v-text-field>
                    </v-flex>
                    <v-btn color="primary" @click="createProject" class="mr-0">Create</v-btn>
                </v-layout>
                <v-layout wrap style="margin: -10px">
                    <div
                        v-for="project in campaignSearch"
                        :key="project.id"
                        class="campaign-container"
                        @click="selectProject(project)"
                    >
                        <div class="campaign-name">{{$t('campaign')}} {{project.name}}</div>
                        <div class="campaign-bot">{{$t('bot')}} {{project.bot_name}}</div>
                        <div class="campaign-description">{{project.description}}</div>
                    </div>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import { mapState } from 'vuex'
import FormMixin from '@/mixins/FormMixin'
import DialogPromiseMixin from '@/mixins/DialogPromiseMixin'
import _ from 'lodash'

export default {
    name: 'ProjectSelector',
    mixins: [FormMixin, DialogPromiseMixin],
    data () {
        return {
            search: ''
        }
    },
    computed: {
        ...mapState({
            projects: state => state.user.projects
        }),
        headers () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('name'),
                    value: 'name'
                },
                {
                    text: this.$t('bot'),
                    value: 'bot_name'
                },
                {
                    text: this.$t('description'),
                    value: 'description'
                }
            ])
        },
        campaignSearch () {
            if (this.search.length > 0) {
                let search = this.search.toLowerCase()
                return _.filter(this.projects, campaign => campaign.name.toLowerCase().includes(search))
            }
            return this.projects
        }
    },
    methods: {
        selectProject (project) {
            this.close()
            this.promise.resolve(project)
        },
        createProject () {
            this.$appService.createProject().then(
                result => {
                    this.$store.dispatch(this.$actionTypes.user.GET_PROJECTS)
                }
            )
        }
    }
}
</script>

<style scoped lang="scss">
    .campaign-container {
        width: 224px;
        height: 167px;
        background: #C4C4C4;
        padding: 10px;
        cursor: pointer;
        margin: 10px;

        &:hover {
            background: #ece4bb;
        }

        .campaign-name {
            font-size: 16px;
            text-transform: capitalize;
        }

        .campaign-bot {
            color: #616161;
            text-transform: capitalize;
            width: 50%;
            border-bottom: 1px solid #000;
            margin: 5px 0;
        }

        .campaign-description {
            text-transform: capitalize;
        }
    }
</style>
